import { lazy } from 'react';

export const CalendarPage = lazy(() => import('./CalendarPage'));
